const ITEM_HIDDEN_CLASS = 'item--is-hidden';
const BUTTON_HIDDEN_CLASS = 'button--is-hidden';

const LOADMORE_BUTTON_HOOK = '[js-hook-load-more-button]';
const LOADMORE_ITEM_HOOK = '[js-hook-load-more-item]';

class loadMore {
    constructor() {
        this.init();
    }

    init() {
        this.getLoadmoreButtons();
        this.bindEvents();
    }

    getLoadmoreButtons() {
        this.loadMoreButtons = [...document.querySelectorAll(LOADMORE_BUTTON_HOOK)];
    }

    /**
     * Bind all events
     */
    bindEvents() {
        if (this.loadMoreButtons.length) {
            this.loadMoreButtons.forEach(button => {
                if (button._isInitialized) return;
                button.addEventListener('click', e => {
                    this.loadMore(e);
                });
                button._isInitialized = true;
            });
        }
    }

    loadMore(e) {
        const { currentTarget } = e;
        if (!currentTarget) return;

        const { parentNode } = currentTarget;
        if (!parentNode) return;

        this.loadmoreItems = [...parentNode.querySelectorAll(LOADMORE_ITEM_HOOK)];

        this.loadmoreItems.forEach(button => {
            button.classList.remove(ITEM_HIDDEN_CLASS);
        });

        currentTarget.classList.add(BUTTON_HIDDEN_CLASS);
    }
}

export default new loadMore();
